import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type GiftProps = {
    className?: string;
};

const Gift: FunctionComponent<GiftProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'gift'}
            viewBox="0 0 250 250"
        >
            <path d="M222.2 58.9h-33.1c5.7-2.5 10.2-5.5 13.6-9.1 5.8-6 8.5-13.6 8.2-22.6-.4-11.3-6.7-20.1-17.2-24.2-16-6.2-37.5-.8-51.1 13-7.9 8-13.8 17.7-17.6 28.9-3.8-11.2-9.7-20.9-17.6-28.9C93.8 2.3 72.3-3.2 56.3 3 45.7 7.1 39.4 15.9 39 27.2c-.3 9 2.4 16.6 8.2 22.6 3.4 3.6 8 6.6 13.6 9.1h-33c-2.5 0-4.5 2-4.5 4.5v58.3c0 2.5 2 4.5 4.5 4.5H35V245c0 2.5 2 4.5 4.5 4.5h171c2.5 0 4.5-2 4.5-4.5V126.2h7.2c2.5 0 4.5-2 4.5-4.5V63.4c0-2.5-2-4.5-4.5-4.5zm-77.6 67.3v114.3h-39.1V126.2h39.1zm-39.2-9V67.9h39.1v49.3h-39.1zM149 22.4c8.1-8.2 19.8-12.9 30.5-12.9 3.9 0 7.6.6 11 1.9 5.1 2 11.1 6.4 11.5 16.1.2 6.5-1.6 11.8-5.7 16-9.5 9.8-31 14.8-65.7 15.3 2.9-14.7 9.1-27 18.4-36.4zM48 27.5c.4-9.8 6.5-14.2 11.5-16.1 3.4-1.3 7.1-1.9 11-1.9 10.7 0 22.4 4.7 30.5 12.9 9.4 9.5 15.5 21.7 18.4 36.5-34.8-.5-56.3-5.5-65.7-15.3-4.1-4.3-5.9-9.5-5.7-16.1zM32.3 67.9h64.2v49.3H32.3V67.9zM44 126.2h52.4v114.3H44V126.2zm162 114.3h-52.4V126.2H206v114.3zm11.7-123.3h-64.2V67.9h64.2v49.3z" />
        </svg>
    );
};

export default Gift;
